import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { applicationMessages, toasterMessages } from '@messages/*';

enum PaymentStatus {
  FREETRAIL = 'Free Trial',
  PAID = 'Subscription Active',
  LOCK = 'Free Trial Expired',
  CANCEL_REQUESTED = 'Subscription Inactive'
}

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent implements OnInit {

  invoices: any[] = [];
  paymentStatus: string;
  subscriptionName: string = 'Free Plan';
  planAmount: number = 0;
  nextBillingDate: string = '';

  candidatesScreened: number = 0;
  totalCandidatesLimit: number = 1000;
  teamMembersCount: number = 0;
  totalTeamLimit: number = 5;

  isLoading: boolean = false;

  constructor(
    private dashboardService: DashboardService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getBillingInfo();
    this.getUsageStats();
  }

  getBillingInfo() {
    this.isLoading = true;
    this.dashboardService.getAdminProfile().subscribe((res: any) => {
      this.isLoading = false;
      this.paymentStatus = PaymentStatus[res.paymentStatus];
      this.subscriptionName = res?.plan?.name || 'Free Plan';
      this.planAmount = res?.plan?.amount || 0;

      this.teamMembersCount = res?.admins?.length || 0;

      if (this.paymentStatus === PaymentStatus.PAID || this.paymentStatus === PaymentStatus.CANCEL_REQUESTED) {
        this.getInvoices();
      }
    }, (err) => {
      this.isLoading = false;
    });
  }

  getUsageStats() {
    this.dashboardService.getAssessmentStats('').subscribe((res: any) => {
      if (res) {
        this.candidatesScreened = res.assessed || 0;
      }
    });
  }

  private getInvoices(): void {
    this.dashboardService.getInvoices().subscribe((res) => {
      if (res && res.invoices) {
        this.invoices = res.invoices.map(inv => ({
          ...inv,
          date: new Date(inv.created * 1000).toLocaleDateString(),
          amount: (inv.amount_paid / 100).toFixed(2),
          status: inv.status,
          shortUrl: inv.hosted_invoice_url || inv.invoice_pdf
        }));
      }
    });
  }

  downloadInvoice(item: any) {
    if (item.shortUrl) {
      window.open(item.shortUrl, '_blank');
    }
  }

  cancelPaymentSub(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'delete-dialog-container',
      data: { danger: true, messageBody: applicationMessages.cancelSubscriptionConfirm }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.dashboardService.cancelSubscription().subscribe(() => {
          this.toastr.success(toasterMessages.cancelSubscriptionSuccess);
          this.getBillingInfo();
        });
      }
    });
  }

  subscribePlan(): void {
    this.router.navigate(['dashboard/pricing']);
  }
}
